import { PropsWithComponentData, useChildrenWithoutFragment } from '@yimoka/react';
import { Carousel as AntCarousel, CarouselProps as AntCarouselProps } from 'antd';
import React, { forwardRef } from 'react';

export type CarouselProps = PropsWithComponentData<AntCarouselProps>;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Carousel = forwardRef<any, CarouselProps>((props, ref) => {
  const { children, data, dataKey, store, ...rest } = props;
  const curChildren = useChildrenWithoutFragment(children);
  return <AntCarousel {...rest} ref={ref}>{curChildren}</AntCarousel>;
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CarouselTodo = forwardRef<any, CarouselProps>((props, ref) => {
  const { children, data, dataKey, store, ...rest } = props;
  // const curData = useComponentData([data], dataKey, store);
  // const items = useSchemaItemsToItems(curData);
  // TODO: 实现
  const curChildren = useChildrenWithoutFragment(children);
  return <AntCarousel {...rest} ref={ref}>{curChildren}</AntCarousel>;
});
